import React, { useCallback, useState } from 'react';

import isNaN from 'lodash/isNaN';
import isNil from 'lodash/isNil';

import Picker from '../Picker';
import { SelectPickerConfig } from './interfaces';

export const nameFilter = (opt: any, query: string) => {
  if (!opt) {
    return false;
  }

  const optLabel = opt.name;

  if (!query) {
    return true;
  }
  return optLabel.toLowerCase().includes(query.trim().toLowerCase());
};

export const SelectPicker = ({
  data,
  value,
  error,
  onSubmit,
  onClose,
  multiple = false,
  title,
  filter = nameFilter,
  getLabel,
  getBadge,
  secondaryActions,
  primaryActions,
  add,
  addText,
  onAdd,
  components,
  DataListProps,
  isLoading,
}: SelectPickerConfig) => {
  const [temporaryValue, setTemporaryValue] = useState(() =>
    !(isNil(value) || isNaN(value)) ? value : []
  );

  const isSelected = (opt: any) => {
    const optValue = opt.id;
    let selected;
    if (multiple) {
      selected = temporaryValue?.some((v: number | string) => v === optValue);
    } else {
      selected = temporaryValue === optValue;
    }

    return selected;
  };

  const handleItemClick = useCallback(
    (_: any, opt: any) => {
      const optValue = opt.id;
      let selected;

      if (multiple) {
        selected = temporaryValue?.some((v: number | string) => v === optValue);

        if (selected) {
          setTemporaryValue((prev: any[]) => {
            return prev?.filter((v: number | string) => v !== optValue);
          });
        } else {
          setTemporaryValue((prev: any[]) => [...(prev || []), optValue]);
        }
      } else {
        onSubmit(optValue);
      }
    },
    [setTemporaryValue, onSubmit, multiple, temporaryValue]
  );

  const handleApply = useCallback(() => {
    onSubmit(temporaryValue);
  }, [onSubmit, temporaryValue]);
  return (
    <Picker
      data={data}
      title={title}
      error={error}
      onSubmit={handleApply}
      onClose={onClose}
      onItemClick={handleItemClick}
      isSelected={isSelected}
      apply={multiple}
      filter={filter}
      getLabel={getLabel}
      getBadge={getBadge}
      secondaryActions={secondaryActions}
      primaryActions={primaryActions}
      add={add}
      addText={addText}
      onAdd={onAdd}
      components={components}
      DataListProps={DataListProps}
      isLoading={isLoading}
    />
  );
};
